import { useContext, useEffect, useState } from 'react';
import { addDesktopItemToLast, pushToVersions, setSectionFormType, updateVersionIndex } from '../../../../../Features/storefrontSlice';
import { useDispatch, useSelector } from 'react-redux';
import CrossGray from '../../../../../Assets/StorefrontIcons/CrossGray.svg';
import OfferBox from './OfferBox';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { v4 as uuidv4 } from 'uuid';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { apiV1 } from '../../../../../Auth/Interceptor';

function OfferDisplayDesktopForm() {
    const dispatch = useDispatch();

    const {
        offerSectionDesktop,
        setOfferSectionDesktop,
    } = useContext(StorefrontContext);

    const desktopVersionStack = useSelector((state) => state.storefront.desktopVersionStack);
    const desktopVersionIndex = useSelector((state) => state.storefront.desktopVersionIndex);

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const [offerList, setOfferList] = useState([]);

    const defaultFormErrors = {
        title: '',
        offerId: '',
    }
        
    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    function closeForm() {
        dispatch(setSectionFormType(null));
        setOfferSectionDesktop({
            offers: [],
            title: '',
        });
    }

    function handleChange(e) {
        setOfferSectionDesktop({
            ...offerSectionDesktop,
            title: e.target.value,
        });
    }

    function handleSave() {
        const validationErrors = {};

        if(!offerSectionDesktop.title) {
            validationErrors.title = 'Required field';
        }
        if(offerSectionDesktop.offers.length === 0) {
            validationErrors.offerId = 'Select at least one offer';
        }

        if(Object.keys(validationErrors).length === 0) {
            setFormErrors(defaultFormErrors);

            const currentVersion = versionStack[versionIndex];

            const newOfferData = offerSectionDesktop.offers.map(offer => {
                return {
                    id: offer.id,
                    couponImage: offer.pic,
                    couponName: offer.couponName,
                }
            });

            const tempVersionData = [ ...currentVersion.versionData ];
            const tempWebVersionData = [ ...currentVersion.webVersionData ];

            const offerDataIndex = tempVersionData.findIndex(
                item => item.item.typeData === 'OFFER_DISPLAY'
            );

            const offerDesktopDataIndex = tempWebVersionData.findIndex(
                item => item.item.typeData === 'OFFER_DISPLAY'
            );

            if (offerDataIndex !== -1) {
                tempVersionData[offerDesktopDataIndex] = {
                    ...tempVersionData[offerDesktopDataIndex],
                    item: {
                        ...tempVersionData[offerDesktopDataIndex].item,
                        name: offerSectionDesktop.title,
                        offersList: newOfferData,
                    }
                };

                tempWebVersionData[offerDataIndex] = {
                    ...tempWebVersionData[offerDataIndex],
                    item: {
                        ...tempWebVersionData[offerDataIndex].item,
                        name: offerSectionDesktop.title,
                        offersList: newOfferData,
                    }
                };

                const newIndex = versionStack[versionStack.length - 1].index + 1;

                const newVersion = {
                    ...currentVersion,
                    index: newIndex,
                    versionData: tempVersionData,
                    webVersionData: tempWebVersionData,
                    comment: 'update desktop offer section',
                }

                dispatch(pushToVersions(newVersion));
                dispatch(updateVersionIndex(newIndex));
            }
            else {

                const object = {
                    id: uuidv4(),
                    typeData: 'OFFER_DISPLAY',
                    name: offerSectionDesktop.title,
                    offersList: newOfferData
                }

                dispatch(addDesktopItemToLast(object));
            }
            closeForm();
        }
        else {
            setFormErrors(validationErrors);
        }
    }

    useEffect(() => {
        const fetchCoupons = async () => {
            try {
                const response = await apiV1.get('coupon/seller');
                if(response?.status === 200) {
                    setOfferList(response.data.data);
                }
                else {
                    showToast('Error fetching categories.', 'error');
                }
            }
            catch(err) {
                showToast('Error fetching categories.', 'error');
            }
        }

        fetchCoupons();
    }, []);

    useEffect(() => {
        async function setOffers() {
            const tempVersion = versionStack[versionIndex]?.webVersionData;

            if (tempVersion && tempVersion.length > 0) {
                const foundItem = tempVersion.find(item => item.item.typeData === 'OFFER_DISPLAY');

                if (foundItem) {
                    const { item } = foundItem;

                    try {
                        const offersList = await Promise.all(item.offersList.map(async offer => {
                            const response = await apiV1.get(`coupon/seller/${offer.id}`);
                            if (response?.status === 200) {
                                const offerData = response.data.data;

                                if(offerData) {
                                    const object = {
                                        id: offer.id,
                                        couponName: offerData.couponName,
                                        typeCoupon: offerData.typeCoupon,
                                        startDate: offerData.startDate,
                                        endDate: offerData.endDate,
                                        isVisible: true,
                                        pic: offerData.pic,
                                    }
                                    return object;
                                }
                            }
                            return null;
                            })
                        );

                        const filteredOffers = offersList.filter(offer => offer !== null);

                        setOfferSectionDesktop({
                            offers: filteredOffers,
                            title: item.name,
                        });
                    }
                    catch (error) {
                        console.error('Error fetching offers:', error);
                    }
                }
                else {
                    console.log('No item with typeData "OFFER_DISPLAY" found.');
                }
            }
        }

        setOffers();
        // eslint-disable-next-line
    }, [desktopVersionStack, desktopVersionIndex]);

    return (
        <div className='w-[305px] h-full bg-[#FFFFFF] border-l border-[#EAEAEA] flex flex-col gap-4 select-none relative'>
            <div className="flex items-center justify-between">
                <p className='font-semibold text-[20px] leading-6 text-[#121212] pl-3'>Offer Display</p>

                <div className="size-11 p-[10px] flex items-center justify-center">
                    <button onClick={closeForm} className='size-6 flex items-center justify-center outline-none'>
                        <img src={CrossGray} alt="" />
                    </button>
                </div>
            </div>

            <div className="h-[calc(100%-44px)] flex flex-col gap-3 px-3 overflow-y-scroll no-scrollbar pb-16">
                <div className="flex flex-col gap-4">
                    <div className="flex items-center justify-between">
                        <label htmlFor="section-name" className='font-medium text-[14px] leading-[22px] text-[#121212]'>Section name</label>

                        <p className='text-[12px] leading-5 text-[#EF4444]'>{formErrors.title}</p>
                    </div>

                    <input 
                        id='section-name' 
                        name='section-name' 
                        className='outline-none border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-[9px] text-[#121212] placeholder:text-[#666666]' 
                        placeholder='Enter section name' 
                        type="text" 
                        value={offerSectionDesktop.title} 
                        onChange={handleChange} 
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <p className='font-medium text-base text-[#000000]'>Offers</p>

                        <p className='text-[12px] leading-5 text-[#EF4444]'>{formErrors.offerId}</p>
                    </div>

                    {offerList?.map(offer => {
                        const isSelected = offerSectionDesktop.offers.find(item => item.id === offer.id);

                        return (
                            <OfferBox 
                                key={offer.id} 
                                id={offer.id} 
                                offer={offer} 
                                isSelected={isSelected} 
                            />
                        );
                    })}
                </div>
            </div>

            <div className="absolute bottom-0 left-0 w-full p-3 bg-[#FFFFFF]">
                <button onClick={handleSave} className='w-full outline-none px-4 py-[6px] bg-primaryColor hover:bg-primaryAccent rounded-md font-semibold text-[12px] leading-6 text-buttonText'>Save changes</button>
            </div>
        </div>
    );
}

export default OfferDisplayDesktopForm;
